import { CommonWork } from '../CommonWork'
import { checkDate } from '../../scripts/validation'
import { List } from '../List'

export class PrePrintParent extends List {
  constructor(obj) {
    super(PrePrint, obj)
  }
}

export class PrePrint {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.editionName = obj?.editionName || null
    this.editionState = obj?.editionState || null
    this.redactor = obj?.redactor || null
    this.applicationDate = obj?.applicationDate || null
    this.interactionType = obj?.interactionType || null
    this.publicationForm = obj?.publicationForm || null
  }

  get fullBibliographicDescription() {
    const names = []
    for (const author of this.commonWork.authors.list) {
      if (author.employee)
        names.push(`${author.employee.lastName}, ${author.employee.firstName[0]}. ${author.employee.middleName[0]}.`)

      if (author.nameRus) {
        const splitName = author.nameRus?.split(' ')
        if (splitName?.length !== 3) return ''
        names.push(`${splitName[0]}, ${splitName[1]?.[0]}. ${splitName[2]?.[0]}.`)
      }
    }

    if (this.commonWork.workName && this.applicationDate && checkDate(this.applicationDate)) {
      return `${this.commonWork.workName}. Дата подачи заявки ${this.applicationDate} г.`
    } else if (this.commonWork.year && names.length && this.commonWork.workName && this.editionState && this.redactor) {
      return `${names.join(', ')} // ${this.commonWork.workName}. Под редакцией ${this.redactor}. // ${
        this.editionState.name
      }. ${this.commonWork.year.year}.`
    } else {
      return null
    }
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      editionName: this.editionName,
      editionState: this.editionState,
      redactor: this.redactor,
      fullBibliographicDescription: this.fullBibliographicDescription,
      applicationDate: this.applicationDate,
      interactionType: this.interactionType,
      publicationForm: this.publicationForm
    }
  }
}
